export interface WizardState {
  type: ActionType | null;
  selection: any;
  checkout: boolean;
  years: number;
}

export enum ActionType {
  Individual = "individual",
  Household = "household",
}

export interface SelectionType {
  step: number;
  selection: number | string;
}